import React, { Fragment, useState } from "react";
import { apiJson } from "../../api/Api";
import { toast } from "react-toastify";

import ClipLoader from "react-spinners/ClipLoader";
import { Redirect } from "react-router";
import $ from "jquery";
import "./createmodal.scss";
import { getClass } from "../../utils/utils";

const CreateModal = (props) => {
  const [areaData, setAreaData] = useState("");
  const [loading, setLoading] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (e) => {
    setAreaData(e.target.value);
  };

  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const createDispute = () => {
    setError(false);
    if (areaData.length > 9) {
      setLoading(true);
      apiJson.disputes
        .createDispute({
          dispute: {
            order_id: props.orderDetail.id,
            line_item_id: props.itemDetail.id,
            description: areaData,
          },
        })
        .then((response) => {
          if (response.success) {
            setLoading(false);
            setRedirect(true);
            $(".right").css({ overflow: "auto" });
            props.onCreate();
          } else if (!response.status) {
            setLoading(false);
            message = response.message
              ? response.message !== ""
                ? response.message
                : "something went wrong"
              : "something went wrong";
            showError();
            $(".right").css({ overflow: "auto" });
            props.onCreate();
          } else {
            setLoading(false);
            $(".right").css({ overflow: "auto" });
            props.onCreate();
            if (response.status >= 400 && response.status < 500) {
              message = response.message
                ? response.message
                : response.errors
                ? response.errors
                : "something went wrong";
              showError();
            } else {
              message = response.message
                ? response.message !== ""
                  ? response.message
                  : "something went wrong"
                : "something went wrong";
              showError();
            }
          }
        });
    } else {
      setError(true);
    }
  };

  return (
    <Fragment>
      <div className="create-modal">
        <div className="header-row w-100">{props.heading}</div>
        <div className="boday-row w-100">
          <div className="input-group-row w-100 d-flex flex-column">
            <div className="input-row d-flex align-items-center w-100">
              <div className="label">Order No:</div>
              <div className="value">{props.orderDetail.id}</div>
            </div>
            <div className="input-row d-flex align-items-center w-100">
              <div className="label">Item:</div>
              <div className="value">{props.itemDetail.id}</div>
            </div>
            <div className="input-row description-row d-flex align-items-center w-100">
              <div className="label">Description:</div>
              <div className={`value`}>
                <textarea
                  name="description"
                  value={areaData}
                  onChange={handleChange}
                  rows={5}
                  className={`${getClass(error)}`}
                />
                {error && (
                  <div style={{ color: "red", fontSize: "14px" }}>
                    Must be 10 characters long
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="buttons-row w-100 d-fex justify-content-start align-items-center">
            <button
              className="cancel-button"
              type="button"
              onClick={props.onCancle}
            >
              Cancle
            </button>
            <button
              className="create-button"
              type="button"
              onClick={createDispute}
              disabled={loading}
            >
              {loading ? (
                <ClipLoader color="#000" loading size={15} />
              ) : (
                "Create"
              )}
            </button>
          </div>
        </div>
      </div>

      {redirect ? <Redirect push to="/vendor/disputes" /> : ""}
    </Fragment>
  );
};

export default CreateModal;
